import React, { useRef, useCallback } from 'react';
import RecipeCards from './RecipeCards';
import useOnClickOutside from './useOnClickOutside';

export default function DetailModal({
  cutInfo,
  cutInfoError,
  closeModalHandler
}) {
  if (cutInfoError) console.log(cutInfoError);

  const modalRef = useRef();
  useOnClickOutside(
    modalRef,
    useCallback(closeModalHandler, [closeModalHandler])
  );

  const {
    name,
    image,
    imageAlt,
    alias,
    butchersNote,
    description,
    nutritionInfo,
    showGraphs,
    nutritionGraphItems,
    relatedRecipes
  } = cutInfo;

  const namePieces = name.split(' ');
  const firstWord = namePieces.shift();
  const restOfName = namePieces.join(' ');

  return (
    <div className="cut-modal modal modal--full modal--visible">
      <div className="modal__dialog">
        <div ref={modalRef} className="modal__content">
          <span
            onClick={() => closeModalHandler()}
            className="cut-modal__close-btn modal__close"
          ></span>
          <a
            onClick={() => closeModalHandler()}
            className="cut-modal__mobile-close btn"
          >
            Close
          </a>

          <div className="cut-modal__cut-info">
            <header className="cut-modal__header modal__header">
              <div className="cut-modal__header-left">
                <h2 className="modal__title">
                  <span>{firstWord}</span>&nbsp;{restOfName}
                </h2>
                {alias && (
                  <div className="u--margin-bottom-20">
                    <span>Also known as: &nbsp;</span>
                    {alias}
                  </div>
                )}
                <div>{description}</div>
              </div>
              <div className="cut-modal__header-right">
                <img src={image} className="card__media" alt={imageAlt} />
              </div>
            </header>
            <section className="modal__body">
              <div className="cut-modal__nutrition">
                {showGraphs && (
                  <>
                    <h3>Nutrition Information</h3>

                    <div className="cut-modal__nutrient-graph">
                      {nutritionGraphItems.map((item, index) => (
                        <NutritionGraphItem key={index} nutrientItem={item} />
                      ))}
                    </div>

                    <div className="u--margin-bottom-30">
                      * Based on a 2,000 calorie diet; ** Percent Daily Values
                      are based on a 2,000-calorie diet
                    </div>
                  </>
                )}
              </div>
              {nutritionInfo && (
                <div className="cut-modal__nutrition-details">
                  {nutritionInfo}
                </div>
              )}
              <div className="cut-modal__butcher-note">
                <h4>Butcher's Note</h4>
                <p>{butchersNote}</p>
              </div>
            </section>
          </div>
          <div className="cut-modal__footer">
            <div className="cut-modal__recommendations">
              <RecipeCards recipes={relatedRecipes} />
            </div>
            <footer className="modal__footer u--text-align-right">
              <a onClick={() => closeModalHandler()} className="btn">
                Close
              </a>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
}

function NutritionGraphItem({ nutrientItem }) {
  const { dv, amount, name, amount_unit } = nutrientItem;

  return (
    <div className="cut-modal__nutrient">
      <div className="cut-modal__nutrient-content">
        <h5>
          {amount}
          {amount_unit ? amount_unit : ''}
        </h5>
        <h6>{name}</h6>
        <p>{`${dv}% DV ${!amount_unit ? '*' : '**'}`}</p>
      </div>
    </div>
  );
}
